import { apiConnector } from '../apiConnector';
import { branchEndpoint } from '../api';

export const getAllBranches = async() => {
  let result = [];
  try{
        const response = await apiConnector("GET", branchEndpoint.GET_ALL_BRANCHES)
        // console.log("GET ALL BRANCHES API RESPONSE...", response);

        if(!response.data.success)
            throw new Error("Could not Fetch Branches");

        result = response?.data;

  }
  catch(error) {
    // console.log("GET ALL BRANCHES API ERROR....", error);
    result = error.response?.data;
  }
  return result;
}

export const addBranch = async (branchData) => {
  let result = {};
  try {
    const response = await apiConnector('POST', branchEndpoint.ADD_BRANCH, branchData);
    result = response.data;
  } catch (error) {
    console.error('ADD BRANCH API ERROR', error);
    result = error.response?.data || { success: false, message: error.message };
  }
  return result;
};

